<script>
  import { onMount } from 'svelte'

  let p = $state(0)

  onMount(() => {
    function next() {
      p += 0.1

      const remaining = 1 - p
      if (remaining > 0.15) setTimeout(next, 500 / remaining)
    }

    setTimeout(next, 250)
  })
</script>

<div class="progress-container">
  <div class="progress" style="width: {p * 100}%"></div>
</div>

{#if p >= 0.1}
  <div class="fade"></div>
{/if}

<style lang="postcss">
  .progress-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: var(--layer-top);
    width: 100%;
    height: 4px;
  }

  .progress {
    position: absolute;
    top: 0;
    left: 0;
    transition: width 0.4s;
    background-color: var(--color-bg-danger);
    height: 100%;
  }

  .fade {
    position: fixed;
    z-index: var(--layer-top);
    animation: fade 2s;
    background-color: rgba(255, 255, 255, 0.4);
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>
